export default __webpack_public_path__ + "static/tshirt2-b713ec0fcff98f05e841c79293fecfcd.jpg";